.buttonAfter,
.buttonBefore,
.componentButtons {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
}

.buttonAfter,
.buttonBefore {
  position: absolute;
  left: 50%;
  z-index: 3;
  height: auto;
}

.buttonAfter {
  bottom: calc(-1 * var(--space-xs));
  transform: translate(-50%, 50%);
}

.buttonBefore {
  top: calc(-1 * var(--space-xs) - 2px);
  transform: translate(-50%, -50%);
  z-index: 4;
}

.componentButtons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: var(--space-m);
  display: flex;
}

.container {
  padding: var(--space-m);
}

.container:hover {
  .componentButtons,
  .buttonAfter,
  .buttonBefore {
    opacity: 1;
    pointer-events: all;
    transition: opacity 0.15s ease-in-out 0.15s;
  }

  .buttonBefore:hover,
  .buttonAfter:hover {
    // add a pseudo element to avoid the dropdown items blinking when moving from button to items
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      height: 5px;
      width: 100%;
      left: 0;
    }
  }
}

.removeButton {
  margin-left: var(--space-s);
}
